export namespace ArrayHelper {
  export function index<T=any, R=T>(array: T[]|null, byPredicate: (item: T) => any, selector?: (item: T) => R) {
    const dictionary: StringMap<R> = {};
    if (array) {
      array.forEach(item => {
        const key = byPredicate(item);
        const value = selector ? selector(item) : item as any;
        dictionary[key] = value;
      });
    }
    return dictionary;
  }

  export function removeItem<T>(array: T[], item: T): boolean {
    const index = array.indexOf(item);

    if (index >= 0) {
      array.splice(index, 1);
      return true;
    }

    return false;
  }
}
